import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type AppBarProps = ComponentProps<typeof AppBar>;

export const AppBar = styled("header", {
  top: "$sizes$app-bar-height",
  left: 0,
  right: 0,
  backgroundColor: "$neutrals-white",
  position: "sticky",
  zIndex: "2",
  borderTop: "1px solid $neutrals-light",

  variants: {
    withBorderTop: {
      true: {
        borderTop: "1px solid $neutrals-light",
      },
      false: {
        borderTop: "none",
      },
    },

    withBorderBottom: {
      true: {
        borderBottom: "1px solid $neutrals-light",
        borderBottomWidth: "1px",
        borderBottomRightRadius: "$none",
        borderBottomLeftRadius: "$none",
        "&::after": {
          position: "absolute",
          content: "",
          left: 0,
          width: "100%",
          bottom: 0,
          border: "0",
          borderBottomWidth: "1px",
          borderStyle: "solid",
          borderColor: "$neutrals-light",
        },
      },
      false: {
        borderBottom: "none",
        borderBottomWidth: "0px",
        borderBottomRightRadius: "$lg",
        borderBottomLeftRadius: "$lg",
        "&::after": {
          borderBottomWidth: "0px",
          border: "none",
        },
      },
    },

    withBoxShadow: {
      true: {
        boxShadow: "$shadow",
      },
      false: {
        boxShadow: "none",
      },
    },
  },
  defaultVariants: {
    withBorderTop: true,
    withBorderBottom: true,
    withBoxShadow: false,
  },

  "&::after": {
    position: "absolute",
    content: "",
    left: 0,
    width: "100%",
    bottom: 0,
    border: "0",
    borderBottomWidth: "1px",
    borderStyle: "solid",
    borderColor: "$neutrals-light",
  },
});

AppBar.displayName = "AppBar";
